import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import PwaUpdatePrompt from './components/PwaUpdatePrompt.jsx'
import { lockZoom } from './lockZoom'
import './index.css'

lockZoom()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <PwaUpdatePrompt />
  </React.StrictMode>,
)

